export default __webpack_public_path__ + "static/statements-screenshot-589be4356c83e406302e13e29fac02e8.png";